import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const localizeProject = (project, t) => {
  if (!project?.id) return project;

  const prefix = `projects.items.${project.id}`;
  const localized = {
    ...project,
    title: t(`${prefix}.title`),
    description: t(`${prefix}.description`),
    features: t(`${prefix}.features`, { returnObjects: true }),
    challenges: t(`${prefix}.challenges`),
  };

  if (project.status) {
    localized.status = t(`${prefix}.status`, { defaultValue: project.status });
  }

  return localized;
};

export const useLocalizedProject = (project) => {
  const { t } = useTranslation();

  return useMemo(() => localizeProject(project, t), [project, t]);
};

export const useLocalizedProjects = (projects) => {
  const { t } = useTranslation();

  return useMemo(
    () => projects.map((project) => localizeProject(project, t)),
    [projects, t],
  );
};

export default useLocalizedProject;
